import EnterprisesForm from './EnterprisesForm';

export default EnterprisesForm;
